import React from 'react';

const MessengerPageIcon = ({ color = "currentColor", ...props }) => (
  <svg width="24" viewBox="0 0 24 24" {...props}><path fill={color} d="M16.939 3A5.057 5.057 0 0 1 22 8.05v7.9c0 2.79-2.27 5.05-5.061 5.05H7.06A5.057 5.057 0 0 1 2 15.95v-7.9A5.05 5.05 0 0 1 7.06 3Zm1.131 5.2a.76.76 0 0 0-.561.2L13 12a1.566 1.566 0 0 1-2 0L6.5 8.4a.76.76 0 0 0-1 .07c-.27.27-.3.7-.071 1l.131.13 4.55 3.55a3.143 3.143 0 0 0 3.909 0l4.511-3.61.08-.08a.773.773 0 0 0-.011-1 .84.84 0 0 0-.529-.26Z" /></svg>
)

export default MessengerPageIcon;
